import type { PanelSenderSessionRow } from '@/api/sender-sessions';
import { cn } from '@/lib/utils';
import SenderStatusChip from '@/pages/sender/components/sender-status-chip';
import { senderSurfaceEmphasisClass } from '@/pages/sender/components/sender-surface';
import {
	formatSessionWhen,
	sessionDisplayStatusLabel,
	sessionDisplayStatusToChipTone,
	sessionPrimaryTitle,
	sessionSecondaryLine,
} from '@/pages/sender/sender-session-display';

interface SenderSessionListItemProps {
	session: PanelSenderSessionRow;
	selecting: boolean;
	selected: boolean;
	onToggle: () => void;
}

export default function SenderSessionListItem({
	session,
	selecting,
	selected,
	onToggle,
}: SenderSessionListItemProps) {
	const secondary = sessionSecondaryLine(session);

	return (
		<div className={cn(senderSurfaceEmphasisClass, 'px-3 py-3')}>
			<div className='flex min-h-11 items-start gap-2'>
				{selecting ? (
					<input
						type='checkbox'
						className='mt-1 shrink-0'
						checked={selected}
						onChange={onToggle}
						aria-label={`Выбрать ${sessionPrimaryTitle(session)}`}
					/>
				) : null}
				<div className='min-w-0 flex-1'>
					<p className='text-[15px] font-medium truncate'>{sessionPrimaryTitle(session)}</p>
					{secondary ? (
						<p className='mt-0.5 text-[13px] text-muted-foreground truncate'>{secondary}</p>
					) : null}
					<div className='mt-1.5 flex flex-wrap items-center gap-1.5'>
						<SenderStatusChip
							label={sessionDisplayStatusLabel(session.displayStatus)}
							tone={sessionDisplayStatusToChipTone(session.displayStatus)}
						/>
						<span className='text-[13px] text-muted-foreground tabular-nums'>
							{formatSessionWhen(session)}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
}
